import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Workshops from "./pages/Workshops";
import Training from "./pages/Training";
import AdviceReports from "./pages/AdviceReports";
import Transformations from "./pages/Transformations";
import BookConsultation from "./pages/BookConsultation";
import StrategyCheck from "./pages/StrategyCheck";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/workshops" element={<Workshops />} />
        <Route path="/training" element={<Training />} />
        <Route path="/advice-reports" element={<AdviceReports />} />
        <Route path="/transformations" element={<Transformations />} />
        <Route path="/strategy-check" element={<StrategyCheck />} />
        <Route path="/book-consultation" element={<BookConsultation />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
